import { Fonts } from 'common-types';

export const FONT_ORACLE = `${Fonts.ABC_ORACLE}, sans-serif`;

export const TEXT_PRIMARY = '#0f0f0f';
export const TEXT_SECONDARY = '#888';
export const GREY_50 = '#f8f8f8';
export const GREY_150 = '#efefef';
export const STROKE_SECONDARY = '#cecece';

export const BRAND_GRADIENT = 'linear-gradient(to top, #c1fd79 0.18%, #fffc7c 127.49%)';
export const GREY_GRADIENT = 'linear-gradient(to bottom, #f8f8f8, #efefef)';

export const PAGE_MAX_WIDTH = 1232;
export const CARD_GAP = 6; // 24px (spacing x4 * 6 = 24)
export const SECTION_GAP = 18; // 72px (spacing x4 * 18 = 72)
